<template>
  <div id="printPage" class="page" style="margin:0 auto; width:980px;border:0px solid #E8E8EC;">
    <div class="title">儿童多动症筛查</div>
    <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: left;">
      <tbody>
        <tr style="line-height: 25px;border:none;"><td style="border:none;">测评机构： {{form.institution_name}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td style="border:none;">测评时间： {{form.medicalDate}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td style="border:none;">测评内容： Conners儿重多动症及相关行为量表</td></tr>
      </tbody>
    </table>

    <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: center;margin-top: 10px;margin-bottom: 10px;">
      <tbody>
        <tr style="background-color: #ddd;height:5px;line-height:35px;font-size:18px;font-weight: 600;">
          <td><p>第一部分 受测试者基本信息</p></td>
        </tr>
      </tbody>
    </table>

    <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: left;">
      <tbody>
        <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">姓名： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.name}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">性别： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.gender === 1 ? "男" : form.gender === 2 ? "女" : ""}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">年龄： </td><td colspan="7" style="border:none;font-weight: 600;">{{(form.age + "").length > 0 ? form.age + "岁" : ""}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">出生日期： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.birthday}}</td></tr>
        <tr style="line-height: 25px;border:none;"><td colspan="1" style="border:none;">与儿童关系： </td><td colspan="7" style="border:none;font-weight: 600;">{{form.relation}}</td></tr>
      </tbody>
    </table>

    <table class="header" cellspacing="0" cellpadding="0" border="0" style="text-align: center;margin-top: 15px;" >
      <tbody>
        <tr style="background-color: #ddd;height:35px;line-height:35px;"><td colspan="8" style="font-size: 18px;font-weight: 600;">第二部分 结果信息</td></tr>
        <tr style="background-color: #9e9e9e1f;line-height: 35px;"><td>类型</td><td>得分</td><td>参考分值</td><td>结论</td></tr>
        <tr style="line-height: 30px;"><td>品行问题得分</td><td>{{form.conduct}}</td><td>0~3分{{ form.conductRange ? "，<" + form.conductRange + "正常" : "" }}</td><td>{{form.conductResult}}</td></tr>
        <tr style="line-height: 30px;"><td>学习问题得分</td><td>{{form.study}}</td><td>0~3分{{ form.studyRange ? "，<" + form.studyRange + "正常" : "" }}</td><td>{{form.studyResult}}</td></tr>
        <tr style="line-height: 30px;"><td>心身问题得分</td><td>{{form.psychosoma}}</td><td>0~3分{{ form.psychosomaRange ? "，<" + form.psychosomaRange + "正常" : "" }}</td><td>{{form.psychosomaResult}}</td></tr>
        <tr style="line-height: 30px;"><td>冲动-多动得分</td><td>{{form.hyperactivity}}</td><td>0~3分{{ form.hyperactivityRange ? "，<" + form.hyperactivityRange + "正常" : "" }}</td><td>{{form.hyperactivityResult}}</td></tr>
        <tr style="line-height: 30px;"><td>焦虑得分</td><td>{{form.anxiety}}</td><td>0~3分{{ form.anxietyRange ? "，<" + form.anxietyRange + "正常" : "" }}</td><td>{{form.anxietyResult}}</td></tr>
      </tbody>
    </table>

    <table cellspacing="2" cellpadding="2" border="3" style="text-align: center;margin-top: 15px;" >
      <tbody>
        <tr style="background-color: #ddd;height:35px;line-height:35px;"><td colspan="8" style="font-size: 18px;font-weight: 600;">第三部分 结论信息</td></tr>
        <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">结论类型</td><td colspan="6">多动指数</td></tr>
        <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">测评得分</td><td colspan="6">{{form.totalScore}}</td></tr>
        <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">得分说明</td><td colspan="6">0~3分，&lt;{{ form.simpleSymptomRange }}正常</td></tr>
        <tr style="line-height: 30px;"><td colspan="2" style="width: 30px;">测评结果</td><td colspan="6" style="word-wrap: break-word;overflow: auto;text-align:left;flex-wrap: wrap;justify-content: flex-start;">{{form.result}}</td></tr>
      </tbody>
    </table>

    <table class="container" cellspacing="0" cellpadding="0" border="0" style="border:none;text-align: left;font-size: 17px;margin-top: 20px;" >
      <tbody>
      <tr style="border:none;">
        <td style="text-indent: 2ch;border:none;">Conners父母症状问卷适用于评估3~17岁儿童行为问题，可以对多动症儿童的诊断敏感，对情绪障碍也有辅助作用。作为筛查量表，量表结论仅供参考，如果测评有问题，建议找医疗机构的医生咨询或诊断。</td>
      </tr>
      </tbody>
    </table>

  </div>
</template>
<script>
import {_print} from "@/services/autism/connersParentScale";
export default {
  name: "printConners",
  props: {
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    show: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
  },
  data() {
    return {
      id:"",
      institutionId:"",
      showPrint:false,
      form:{
        id:"",
        medicalDate:"",
        institutionId:"",
        institutionName:"",
        subordinate:"",
        kindergartenName:"",
        name:"",
        gender:"",
        age:"",
        birthday:"",
        contactPerson:"",
        cardNum:"",
        relation:"",
        phone:"",
        address:"",
        currentAddress:"",
        problem:"",
        otherQuestions:"",
        conduct:"",
        conductRange:"",
        conductResult:"",
        study:"",
        studyRange:"",
        studyResult:"",
        psychosoma:"",
        psychosomaRange:"",
        psychosomaResult:"",
        hyperactivity:"",
        hyperactivityRange:"",
        hyperactivityResult:"",
        anxiety:"",
        anxietyRange:"",
        anxietyResult:"",
        totalScore:"",
        simpleSymptomRange:"",
        result:"",
        scoreRemark:"",
        remark:"",
      }
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        if (newVal) {
          this.form = newVal;
        }
      }
    },
    show: {
      handler(newVal) {
        if (newVal) {
          this.showPrint = newVal;
        }
      }
    },
  },
  mounted() {
    if(this.$route.query.institutionId && this.$route.query){
      this.institutionId = this.$route.query.institutionId;
      this.id = this.$route.query.id;
      _print({institutionId: this.institutionId, id: this.id}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.form = res.data
        this.form.institutionName = this.form.institutionName + (this.form.subordinate&&this.form.subordinate.length > 0 ? "-" + this.form.subordinate : "")
      })
    }else{
      this.showPrint = false;
    }
  },
  methods: {

  }
};
</script>
<style lang="postcss" scoped>
@media print {
  @page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}

.page{
  width: 210mm; /* 或者使用px，例如 794px (大约210mm转换为px) */
  height: 297mm; /* 或者使用px，例如 1122px (大约297mm转换为px) */
  margin: 0 auto;
  background-color: white;
  text-align: center;
  overflow:hidden;
  position:relative;
  PAGE-BREAK-AFTER:always;
  padding:50px;
}

.title {margin-top: 30px;margin-bottom: 30px;font-size: 30px;text-align: center;}
table {border-collapse:collapse;border:none;font-size: 15px;width: 100%;}
table, th, td {border: 1px solid #ddd;}
th, td {width: 100px;}
table.header, table.header tr, table.header td {border: 1px solid #ddd;}
</style>
